// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./clients/web/src/stylesheets/widgets/metadataWidget.styl
// module id = 265
// module chunks = 0